import React from "react";
import App_store from './content/app_store.jsx';
import Language_i18 from '../js/useNationalLanguage.jsx';

function DownloadButtons() {
  const { lang } = Language_i18();
  const translations = {
    vi: {
      headline: "Đăng ký thôi! 😍📲💕",
      subtext: "Nhiều tiện ích thú vị miễn phí và an toàn"
    },
    en: {
      headline: "Sign up now! 😍📲💕",
      subtext: "Lots of fun, free, and safe utilities"
    }
  };

  return (
    <div className="px-3 py-2">
      <div className="max-w-3xl mx-auto rounded-3xl bg-gradient-to-br from-pink-100 via-purple-100 to-blue-100 p-[2px] shadow-sm">
        <div className="rounded-2xl bg-pink-50 px-4 py-4 shadow-sm">
          <div style={{ textAlign: "center" }} className="-mt-2 justify-center items-center">
            <div className="mt-1">
              <span className="text-lg  font-bold text-pink-600 animate-pulse">{translations[lang]?.headline || translations.vi.headline}</span>
              <div className="mt-0 mb-4 text-xs text-gray-700" >{translations[lang]?.subtext || translations.vi.subtext}
              </div>
            </div>
            <App_store />
          </div>
        </div>
      </div>
    </div>
  );
}


export default DownloadButtons;
